import template		from "./textbox-colorpicker.html";
import css			from "./textbox-colorpicker.css";
import {Textbox}	from "gui";
import Popup		from "./division-colorpicker.js";

class ColorPicker extends Textbox {
  static constructor() {
    customElements.define("fulljs-textbox-colorpicker", ColorPicker);    
  }
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static get schema() {
    return({
      "description": "User defined colorpicker for illumination module",
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "description": "",
          "default": "#000000"
        }        
      }
    });
  }
  static get designer() {
    return({
      "category": "User Defined",
      "icon": {"context": "actions", "size": 16, "iconname": "color-picker"}
    });
  }  
  constructor(p) {
    super(p);    
    
    this.addEventListener("mousedown", this.this_mousedown_handler.bind(this));
  }
  divisionPopup_input() {
    this.value = this.divisionPopup.value;
    if ("createEvent" in document) {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("input", true, true);
      this.dispatchEvent(evt);
    } else {
      this.fireEvent("input");
    }     
  }
  divisionPopup_change() {
    if ("createEvent" in document) {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", true, true);
      this.dispatchEvent(evt);
    } else {
      this.fireEvent("onchange");
    }     
  }  
  this_mousedown_handler() {
    this.divisionPopup.value = this.value;
  }
  toString() {
    return this.value;
  }
}

ColorPicker.constructor();

export default ColorPicker;